<template>
  <div v-if="credential && credential.apiEncryptedUser && retailPerc === 1">
    <WelcomeModal></WelcomeModal>
    <div class="container-fluid">
      <div class="row footer">
        <div class="col-md-3">
          <img class="px- py-3" :src="getLogoUrl()" />
        </div>
        <div class="col-md-6">
          <div class="row policies-row">
            <div class="col-md-4">
              <a target="_blank" href="https://www.gioielleriaitaliana.com/privacy-policy-2/">PRIVACY POLICY</a>
            </div>
            <div class="col-md-4">
              <a target="_blank" href="https://www.gioielleriaitaliana.com/cookie-policy/">COOKIE POLICY</a>
            </div>
            <div class="col-md-4">
            </div>
          </div>
          <div class="row contacts-row">
            <div class="col-md-4">
              <a href="tel:+393470419885">+393470419885</a>
            </div>
            <div class="col-md-4 d-block d-md-none">
              <a href="https://wa.me/3470419885">{{ $t("contact_us_whatsApp") }}</a>
            </div>
            <div class="col-md-4 d-none d-md-block whatsapp-col">
              <a href="https://wa.me/3470419885">{{ $t("contact_us_whatsApp") }}</a>
            </div>
            <div class="col-md-4">
              <a href="mailto:info@gioielleriaitaliana.com">info@gioielleriaitaliana.com</a>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <h5 class="f-title text-uppercase">{{ $t("follow_us") }}</h5>
          <div>
            <a class="social-icon" target="_blank" href="https://www.instagram.com/gioielleriaitaliana/?hl=it">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a class="social-icon" target="_blank" href="https://www.facebook.com/Gioielleria-Italiana-102304924791127">
              <font-awesome-icon :icon="['fab', 'facebook']" />
            </a>
            <a class="social-icon" target="_blank" href="https://www.linkedin.com/company/gioielleria-italiana/">
              <font-awesome-icon :icon="['fab', 'linkedin']" />
            </a>
          </div>
        </div>
        <div class="col-md-12">
          Copyright © 2022 Gioielleria Italiana S.r.l. - P. IVA 01797090097 - All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WelcomeModal from "./WelcomeModal.vue";

export default {
    name: "Footer",
    computed: mapState({
        credential: (state) => state.config.credential,
        retailPerc: (state) => state.detail.retailPerc,
    }),
    methods: {
        getLogoUrl: function () {
            return require('../assets/logo_GI_blu_' + this.credential.locale.substring(0, 2) + '.png');
        }
    },
    components: { WelcomeModal }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.f-title {
  font-size: 20px;
  font-weight: bold;
}


@media only screen and (max-width: 768px) {
  .f-title {
    font-size: 18px;
    text-transform: uppercase;
  }
}

.footer {
  color: var(--primary-color-1);
  border-top: 1px solid var(--primary-color-1);
  padding-top: 25px;
  padding-bottom: 25px;

  img {
    width: 60%;
  }

  .social-icon {
    color: var(--primary-color-1);
    font-size: 30px;
    padding: 5px;
  }
}

.policies-row {
  padding-bottom: 10px;
  margin-bottom: 13px;
  font-size: 15px;

  a {
    text-decoration: none !important;
    color: var(--primary-color-1);
  }
}

.contacts-row {
  margin-bottom: 20px;
  font-size: 15px;

  .col-md-4 {
    overflow: hidden;
  }

  a {
    text-decoration: none !important;
    color: var(--primary-color-1);
  }
}

.whatsapp-col {
  border: 1px solid;
  border-top: 0;
  border-bottom: 0;
}
</style>
